document.addEventListener("wizzyFeaturedViewLoaded", function () {
  // window.featuredViewConfig.events.registerEvent(
  //   window.featuredViewConfig.events.allowedEvents.PRODUCT_ADDED_TO_WISHLIST,
  //   function (data) {
  //     const mainSwiperWrapper = document.querySelector(".swiper-wrapper");

  //     if (mainSwiperWrapper) {
  //       const slides = mainSwiperWrapper.querySelectorAll(
  //         ":scope > .swiper-slide"
  //        );
  //       console.log("Total Slides:", slides.length);

  //       const activeSlide = mainSwiperWrapper.querySelector(
  //         ":scope > .swiper-slide.swiper-slide-active"
  //       );
  //       console.log("Active Slide:", activeSlide);

  //       if (activeSlide) {
  //         const activeIndex = Array.from(slides).indexOf(activeSlide);
  //         console.log("Active Index:", activeIndex);

  //         const productList = document.querySelectorAll(
  //           "#wizzy-products-list-usf .product-card"
  //         );
  //         console.log("Total Products:", productList.length);

  //         if (productList.length > activeIndex) {
  //           const targetProduct = productList[activeIndex];
  //           console.log("Target Product:", targetProduct);

  //           if (targetProduct) {
  //             const wishlistButton = targetProduct.querySelector(
  //               ".btn--secondary-accent"
  //             );

  //             if (wishlistButton) {
  //               wishlistButton.click();
  //               console.log(
  //                 "✅ Wishlist button clicked for product at index:",
  //                 activeIndex
  //               );
  //             } else {
  //               console.log(
  //                 "❌ Wishlist button NOT found in product at index:",
  //                 activeIndex
  //               );
  //             }
  //           } else {
  //             console.log("❌ Product NOT found at index:", activeIndex);
  //           }
  //         } else {
  //           console.log(
  //             "❌ No corresponding product found for active index:",
  //             activeIndex
  //           );
  //         }
  //       } else {
  //         console.log("❌ No active slide found.");
  //       }
  //     } else {
  //       console.log("❌ No main .swiper-wrapper found.");
  //     }

  //     return data;
  //   }
  // );
  window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
     
      // console.log("Fearture view before_init ",data);
      return data;
    }
      );
  window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.AFTER_PRODUCTS_FETCHED,
    function (data) {
      let results = data.payload.result;
      // console.log(results);

      return (
        results.forEach((result) => {
          result.attributes.forEach((attribute) => {
            // attribute.id === "product_variant_ids" &&
            //   ((result.id = attribute.values[0].value[0]),
              // console.log(attribute.values[0].value[0], result.id));
          });
          result.images.splice(0, 1);
        }),
        // setTimeout(function () {
        //   const cartButton = document.querySelector(
        //     ".wizzy__featuredview__cart__dj89c"
        //   );
        //   if (cartButton) {
        //     cartButton.addEventListener("click", function () {
        //       console.log("in feature view");
        //       const relativeElement = document.querySelector(".relative.header__cart-link");
        //       if (relativeElement) {
        //         relativeElement.click();
        //       }
        //     });
        //   }

        //   document
        //     .querySelector(".wizzy__featuredview__wishlist___e6gQ")
        //     .addEventListener("click", function () {
        //       console.log("in fetaure view");
        //       document.querySelector(".Header__Icon ").click();

        //       setTimeout(function () {
        //         const wishlistCloseButton = document.querySelector(
        //           ".MuiButtonBase-root.MuiIconButton-root.wishlist-hero-header-close"
        //         );
        //         if (wishlistCloseButton) {
        //           wishlistCloseButton.addEventListener("click", function () {
        //             console.log("in feature view");
        //             const closeButton = document.querySelector(
        //               ".wizzy__featuredview__closeButton__OQDqs"
        //             );
        //             if (closeButton) {
        //               closeButton.click();
        //             }
        //           });
        //         }

        //         setTimeout(function () {
        //           const cartButton = document.querySelector(
        //             ".wizzy__featuredview__cart__dj89c"
        //           );
        //           if (cartButton) {
        //             cartButton.addEventListener("click", function () {
        //               console.log("in feature view");
        //               const relativeElement =
        //                 document.querySelector(".relative");
        //               if (relativeElement) {
        //                 relativeElement.click();
        //               }
        //             });
        //           }
        //         }, 500);
        //       }, 500);
        //     });
        // }, 500),
        data
      );
    }
  );
   window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      // console.log("HHHHHHHHHHHHHHHHH",products);
      
      products.forEach((product) => {
        if (product.groupId === "" || product.groupId === null) {
                product.attributes.forEach((attr) => {
                    if (attr.id === "product_variant_ids") {
                      // console.log("Hi from custom feature view");
                        if (typeof product.singleVarientGroupId === "undefined") {
                            product.singleVarientGroupId = product.id
                            product.id = attr.value;
                        }
                    }
                })
            }
      });
      return products;
    }
  );
  // window.featuredViewConfig.events.registerEvent(
  //   window.featuredViewConfig.events.allowedEvents.ADD_TO_CART,
  //   function (data) {
  //     console.log("ADD_TO_CART",data);
  //     return data;
  //   }
  // );

  //   window.featuredViewConfig.events.registerEvent(
  //     window.featuredViewConfig.events.allowedEvents.PRODUCT_ADDED_TO_WISHLIST,
  //     function (payload) {
  //       setTimeout(function () {
  //         document
  //           .querySelector(".wizzy__featuredview__wishlist___e6gQ")
  //           .addEventListener("click", function () {
  //             document.querySelector(".Header__Icon ").click();

  //             setTimeout(function () {
  //               const wishlistCloseButton = document.querySelector(
  //                 ".MuiButtonBase-root.MuiIconButton-root.wishlist-hero-header-close"
  //               );
  //               if (wishlistCloseButton) {
  //                 wishlistCloseButton.addEventListener("click", function () {
  //                   const closeButton = document.querySelector(
  //                     ".wizzy__featuredview__closeButton__OQDqs"
  //                   );
  //                   if (closeButton) {
  //                     closeButton.click();
  //                   }
  //                 });
  //               }
  //             }, 500);
  //           });
  //         const cartButton = document.querySelector(
  //           ".wizzy__featuredview__cart__dj89c"
  //         );
  //         if (cartButton) {
  //           cartButton.addEventListener("click", function () {
  //             console.log("in feature view");
  //             const relativeElement = document.querySelector(".relative");
  //             if (relativeElement) {
  //               relativeElement.click();
  //             }
  //           });
  //         }
  //       }, 500);
  //       return payload;
  //     }
  //   );

  //    window.featuredViewConfig.events.registerEvent(
  //   window.featuredViewConfig.events.allowedEvents.ADD_TO_CART,
  //   function (payload) {
  //     setTimeout(function(){
  //       window.theme.sections.instances[0].initDrawers();
  //     },1000)
  //     return payload;
  //   }
  // );
  //   window.featuredViewConfig.events.registerEvent(
  //     window.featuredViewConfig.events.allowedEvents.ON_FEATURED_VIEW_CLICKED,
  //     function (payload) {
  //       console.log("ON_FEATURED_VIEW_CLICKED");

  //       return payload;
  //     }
  //   );

  // window.featuredViewConfig.events.registerEvent(
  //   window.featuredViewConfig.events.allowedEvents.ON_FEATURED_VIEW_CLICKED,
  //   function (payload) {
  //     const slides = document.querySelectorAll(".swiper-wrapper .swiper-slide");

  //     const activeSlide = document.querySelector(
  //       ".swiper-wrapper .swiper-slide-active"
  //     );

  //     if (activeSlide) {
  //       const activeIndex = Array.from(slides).indexOf(activeSlide);
  //       console.log("Active Index:", activeIndex);

  //       const productList = document.querySelectorAll(
  //         "#wizzy-products-list-usf"
  //       );

  //       if (productList.length > activeIndex) {
  //         const targetProduct = productList[activeIndex];

  //         if (targetProduct) {
  //           const wishlistButton = targetProduct.querySelector(
  //             "button[aria-label='Add to wishlist']"
  //           );

  //           if (wishlistButton) {
  //             wishlistButton.click();
  //             console.log(
  //               "Wishlist button clicked for product at index:",
  //               activeIndex
  //             );
  //           } else {
  //             console.log(
  //               "Wishlist button not found in product at index:",
  //               activeIndex
  //             );
  //           }
  //         } else {
  //           console.log("Product not found at index:", activeIndex);
  //         }
  //       } else {
  //         console.log(
  //           "No corresponding product found for active index:",
  //           activeIndex
  //         );
  //       }
  //     } else {
  //       console.log("No active slide found.");
  //     }

  //     return payload;
  //   }
  // );

  // window.featuredViewConfig.events.registerEvent(
  //   window.featuredViewConfig.events.allowedEvents.BEFORE_PRODUCTS_FETCHED,
  //   function (payload) {
  //     let filters = JSON.parse(payload.filters);
  //     return (
  //       (filters.swatch = [
  //         {
  //           key: "colors",
  //         },
  //         {
  //           key: "sizes",
  //         },
  //       ]),
  //       (payload.filters = JSON.stringify(filters)),
  //       payload
  //     );
  //   }
  // );
  
});
let featuredViewOpened = false;

// Listen for the open button click
document.addEventListener("click", function(event) {
  const openButton = event.target.closest("#init-wizzy-featured-view-button");
  if (openButton && !featuredViewOpened) {
    featuredViewOpened = true;
    // Push state once when featured view opens
    history.pushState({ wizzyFeatured: true }, "", window.location.href);
  }
});

// Handle back button
try {
    

window.addEventListener("popstate", function(event) {
  // Only handle if we opened the featured view
  if (!featuredViewOpened) return;
  console.log("popState",event);
  // Check if featured view is still open
  const isOpen = document.body.classList.contains("wizzyFeaturedViewRendered") || 
                 document.documentElement.classList.contains("wizzyFeaturedViewRendered");
  
  if (isOpen) {
    // Click the close button instead of going back
    const closeButton = document.querySelector(".wizzy__featuredview__closeFeaturedView___GkAL");
    if (closeButton) {
      closeButton.click();
      featuredViewOpened = false; // Reset flag - the pushed state is already removed by back button
    }
  }
});
} catch (error) {
    console.log("Error : ",error);
}